// ---- source script: product(1).html ----

(function(){
  'use strict';
  var menuBtn=document.getElementById('menuBtn');
  var mobileMenu=document.getElementById('mobileMenu');
  if(menuBtn&&mobileMenu) menuBtn.addEventListener('click',function(){mobileMenu.classList.toggle('open');});

  var viewers=143;
  var viewerEls=[].slice.call(document.querySelectorAll('.live-viewers-sync'));
  function updateViewers(){
    var change=Math.floor(Math.random()*7)-3;
    viewers=Math.max(118,Math.min(168,viewers+change));
    viewerEls.forEach(function(el){el.textContent=String(viewers);});
  }
  updateViewers(); setInterval(updateViewers,2600);

  var mainImg=document.getElementById('mainProductImage');
  document.querySelectorAll('.thumb').forEach(function(btn){
    btn.addEventListener('click',function(){
      document.querySelectorAll('.thumb').forEach(function(b){b.classList.remove('active');});
      btn.classList.add('active');
      if(mainImg) mainImg.src=btn.getAttribute('data-img');
    });
  });

  var bundles=[].slice.call(document.querySelectorAll('.bundle'));
  var priceText=document.getElementById('priceText');
  var buttonPrice=document.getElementById('buttonPrice');
  var quickButtonPrice=document.getElementById('quickButtonPrice');
  var stickyAdd=document.getElementById('stickyAdd');
  var selectedPrice=89, qty=1;
  var qtyVal=document.getElementById('qtyVal');
  function refreshPrice(){
    var total=selectedPrice*qty;
    if(priceText) priceText.textContent='$'+selectedPrice;
    if(buttonPrice) buttonPrice.textContent='$'+total;
    if(quickButtonPrice) quickButtonPrice.textContent='$'+total;
    if(stickyAdd) stickyAdd.textContent='Add To Cart $'+total;
    if(qtyVal) qtyVal.textContent=String(qty);
  }
  bundles.forEach(function(bundle){
    bundle.addEventListener('click',function(){
      bundles.forEach(function(b){b.classList.remove('active');});
      bundle.classList.add('active');
      selectedPrice=parseInt(bundle.getAttribute('data-price'),10)||89;
      refreshPrice();
    });
  });
  var minus=document.getElementById('qtyMinus'), plus=document.getElementById('qtyPlus');
  if(minus) minus.addEventListener('click',function(){qty=Math.max(1,qty-1);refreshPrice();});
  if(plus) plus.addEventListener('click',function(){qty=Math.min(9,qty+1);refreshPrice();});

  var cartCount=document.getElementById('cartCount');
  var toast=document.getElementById('toast');
  function addCart(){
    var count=(parseInt(cartCount.textContent,10)||0)+qty;
    cartCount.textContent=String(count);
    if(toast){toast.classList.add('show'); setTimeout(function(){toast.classList.remove('show');},1800);}
  }
  var add=document.getElementById('addToCart');
  var quickAddTop=document.getElementById('quickAddTop');
  if(add) add.addEventListener('click',addCart);
  if(quickAddTop) quickAddTop.addEventListener('click',addCart);
  if(stickyAdd) stickyAdd.addEventListener('click',addCart);
  var cartBtn=document.getElementById('cartBtn');
  if(cartBtn) cartBtn.addEventListener('click',addCart);

  document.querySelectorAll('.acc button').forEach(function(btn){
    btn.setAttribute('aria-expanded', btn.closest('.acc').classList.contains('open') ? 'true' : 'false');
    btn.addEventListener('click',function(){
      var item = btn.closest('.acc');
      item.classList.toggle('open');
      btn.setAttribute('aria-expanded', item.classList.contains('open') ? 'true' : 'false');
    });
  });
  refreshPrice();
})();


// ---- source script: product(1).html ----

(function(){
  'use strict';
  function startAutoVideos(){
    document.querySelectorAll('.proof-auto-video').forEach(function(video){
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.setAttribute('muted','');
      video.setAttribute('playsinline','');
      video.setAttribute('webkit-playsinline','');
      var p;
      try { p = video.play(); } catch(e) {}
      if(p && typeof p.catch === 'function'){
        p.catch(function(){
          var retry = function(){ try{ video.play(); }catch(e){}; document.removeEventListener('touchstart', retry); document.removeEventListener('click', retry); };
          document.addEventListener('touchstart', retry, {once:true, passive:true});
          document.addEventListener('click', retry, {once:true, passive:true});
        });
      }
    });
  }
  document.querySelectorAll('.faq-q').forEach(function(btn){
    btn.addEventListener('click', function(){
      var item = btn.closest('.faq-item');
      if(item) item.classList.toggle('open');
    });
  });
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startAutoVideos, {once:true});
  else startAutoVideos();
  window.addEventListener('load', startAutoVideos, {once:true});
})();


// ---- source script: product(1).html ----

(function(){
  var home = (window.BOO_ROUTES && window.BOO_ROUTES.home) || '/';
  var product = (window.BOO_ROUTES && window.BOO_ROUTES.product) || '/collections/all';
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('a').forEach(function(a){
      var txt = (a.textContent || '').trim().toLowerCase();
      var aria = (a.getAttribute('aria-label') || '').toLowerCase();
      if (txt === 'home' || aria.indexOf('home') !== -1 || a.classList.contains('product-logo') || a.classList.contains('ig-footer-logo')) {
        a.setAttribute('href', home);
      }
      if ((a.getAttribute('href') || '') === '#products') {
        a.setAttribute('href', product);
      }
    });
  });
})();


// ---- source script: product(1).html ----

(function(){
  'use strict';
  function initAccordions(){
    document.querySelectorAll('.accordions .acc').forEach(function(item){
      item.classList.remove('open');
      var oldBtn = item.querySelector('button');
      var content = item.querySelector('.acc-content');
      if(!oldBtn || !content) return;
      var btn = oldBtn.cloneNode(true);
      oldBtn.parentNode.replaceChild(btn, oldBtn);
      var icon = btn.querySelector('span');
      btn.setAttribute('aria-expanded','false');
      if(!content.id){ content.id = 'acc-content-' + Math.random().toString(36).slice(2,8); }
      btn.setAttribute('aria-controls', content.id);
      if(icon) icon.textContent = '+';
      btn.addEventListener('click', function(e){
        e.preventDefault();
        var isOpen = item.classList.toggle('open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        if(icon) icon.textContent = '+';
      }, {passive:false});
    });
  }
  function initMobileVideoRail(){
    var rail = document.querySelector('.proof-video-rail');
    if(!rail) return;
    var down=false,startX=0,scrollLeft=0,moved=false;
    rail.addEventListener('pointerdown', function(e){
      if(window.innerWidth > 768) return;
      down=true;moved=false;startX=e.clientX;scrollLeft=rail.scrollLeft;
      try{rail.setPointerCapture(e.pointerId);}catch(err){}
    }, {passive:true});
    rail.addEventListener('pointermove', function(e){
      if(!down || window.innerWidth > 768) return;
      var dx=e.clientX-startX;
      if(Math.abs(dx)>6) moved=true;
      rail.scrollLeft=scrollLeft-dx;
    }, {passive:true});
    ['pointerup','pointercancel','pointerleave'].forEach(function(ev){
      rail.addEventListener(ev,function(){down=false;}, {passive:true});
    });
  }
  function init(){ initAccordions(); initMobileVideoRail(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();


// ---- source script: product(1).html ----

(function(){
  'use strict';
  if(window.__booProductOfferPopup__) return;
  window.__booProductOfferPopup__ = true;
  function ready(fn){ if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, {once:true}); else fn(); }
  ready(function(){
    var popup = document.getElementById('booOfferPopup');
    var closeBtn = document.getElementById('booOfferClose');
    var browseBtn = document.getElementById('booOfferBrowse');
    var claimBtn = document.getElementById('booOfferClaim');
    if(!popup) return;
    var lastFocus = null;
    function show(){
      if(popup.classList.contains('show')) return;
      lastFocus = document.activeElement;
      popup.classList.add('show');
      popup.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function(){ if(claimBtn) claimBtn.focus({preventScroll:true}); }, 120);
    }
    function hide(){
      popup.classList.remove('show');
      popup.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow = '';
      if(lastFocus && typeof lastFocus.focus === 'function'){
        try{ lastFocus.focus({preventScroll:true}); }catch(e){}
      }
    }
    function claim(){
      hide();
      var add = document.getElementById('addToCart') || document.getElementById('quickAddTop') || document.getElementById('stickyAdd');
      var offer = document.querySelector('.product-info') || document.getElementById('details') || document.body;
      if(offer && offer.scrollIntoView) offer.scrollIntoView({behavior:'smooth', block:'start'});
      if(add){ setTimeout(function(){ try{ add.click(); }catch(e){} }, 280); }
    }
    if(closeBtn) closeBtn.addEventListener('click', hide);
    if(browseBtn) browseBtn.addEventListener('click', hide);
    if(claimBtn) claimBtn.addEventListener('click', claim);
    popup.addEventListener('click', function(e){ if(e.target === popup) hide(); });
    document.addEventListener('keydown', function(e){
      if(!popup.classList.contains('show')) return;
      if(e.key === 'Escape') hide();
      if(e.key === 'Tab'){
        var focusables = [].slice.call(popup.querySelectorAll('button,[href],input,select,textarea,[tabindex]:not([tabindex="-1"])')).filter(function(el){ return !el.disabled && el.offsetParent !== null; });
        if(!focusables.length) return;
        var first = focusables[0], last = focusables[focusables.length - 1];
        if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
      }
    });
    setTimeout(show, window.innerWidth <= 640 ? 950 : 1150);
  });
})();


// ---- source script: product(1).html ----

(function(){
  'use strict';
  function initMobileGalleryPolish(){
    var gallery=document.querySelector('.product-gallery');
    var main=document.querySelector('.main-photo');
    var mainImg=document.getElementById('mainProductImage');
    var thumbs=[].slice.call(document.querySelectorAll('.thumb'));
    if(!gallery||!main||!mainImg||!thumbs.length) return;

    if(!document.getElementById('mobileGalleryCount')){
      var count=document.createElement('div');
      count.id='mobileGalleryCount';
      count.className='mobile-gallery-count';
      main.appendChild(count);
    }
    if(!gallery.querySelector('.product-gallery-note')){
      var note=document.createElement('div');
      note.className='product-gallery-note';
      note.innerHTML='<span>tap a photo to preview</span><span>mobile optimized gallery</span>';
      var thumbsWrap=gallery.querySelector('.thumbs');
      if(thumbsWrap) gallery.insertBefore(note, thumbsWrap);
    }

    function updateCount(index){
      var el=document.getElementById('mobileGalleryCount');
      if(el) el.textContent=(index+1)+' / '+thumbs.length;
    }

    function setActive(btn,index,scrollThumb){
      thumbs.forEach(function(b){b.classList.remove('active');});
      btn.classList.add('active');
      var src=btn.getAttribute('data-img');
      if(src && mainImg.src!==src) mainImg.src=src;
      updateCount(index);
      if(scrollThumb){
        try{btn.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});}catch(e){}
      }
    }

    thumbs.forEach(function(btn,index){
      if(!btn.__booMobileGalleryBound){
        btn.__booMobileGalleryBound=true;
        btn.addEventListener('click',function(){setActive(btn,index,true);},{passive:true});
      }
    });

    var startX=0,startY=0;
    main.addEventListener('touchstart',function(e){
      if(!e.touches||!e.touches.length) return;
      startX=e.touches[0].clientX; startY=e.touches[0].clientY;
    },{passive:true});
    main.addEventListener('touchend',function(e){
      if(!e.changedTouches||!e.changedTouches.length) return;
      var dx=e.changedTouches[0].clientX-startX;
      var dy=e.changedTouches[0].clientY-startY;
      if(Math.abs(dx)<38 || Math.abs(dx)<Math.abs(dy)) return;
      var current=thumbs.findIndex(function(b){return b.classList.contains('active');});
      if(current<0) current=0;
      var next=dx<0 ? Math.min(thumbs.length-1,current+1) : Math.max(0,current-1);
      setActive(thumbs[next],next,true);
    },{passive:true});

    var active=thumbs.findIndex(function(b){return b.classList.contains('active');});
    updateCount(active>=0?active:0);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initMobileGalleryPolish,{once:true});
  else initMobileGalleryPolish();
})();

